import React, { useState } from 'react';
import Request from 'files/Request.js';

import Utils from 'files/Utils.js';
import { EVENTS, logBookingEvent } from 'files/Analytics.js';

const FIRE = '#D63D1F';
const FIRE_GLOW = '#FF6B3D';
const SECONDARY_DARK = '#242F3F';

const ContactForm = ({ utils }) => {

    const isMobile = Utils.isMobile();
    const isCanada = Utils.isCanadianVisitor();

    const [zip, setZip] = useState('');
    const [zipError, setZipError] = useState('');

    const onZipChange = evt => {
        let next = (evt.target.value || '').replace(/\D/g, '').slice(0, 5);
        setZip(next);
        if(zipError) {
            setZipError('');
        }
    }

    const onZipSubmit = async evt => {
        try {

            // prepare value for request
            evt.preventDefault();
            let trimmed = zip.trim();

            // reset zip error field
            setZipError('');

            // track booking-funnel step 1: zip code entered + inspection requested
            logBookingEvent(EVENTS.SCHEDULE_INSPECTION, { form_location: 'contact_form', funnel_step: 1 });

            // submit request to server for
            let { dealerships } = await Request.get(utils, '/dealerships/', {
                type: 'optimal_dealership_for_zipcode',
                zipcode: trimmed
            });

            // throw an error if no dealership was found for the provided zip code
            if(dealerships.length === 0) {
                utils.alert.show({
                    title: 'No Dealers Found',
                    message: 'It looks like there are no authorized dealers in your area at the moment.'
                }); 
                return;
            }

            // launch booking modal with recommended dealership
            utils.booking.show(dealerships);
            
        } catch(e) {
            setZipError(e.message);
        }
    }

    return (
        <section
        id={'contact'}
        style={{
            background: `linear-gradient(to bottom, rgba(214,61,31,0.15), #F5F6FA)`,
            borderTop: `1px solid rgba(214,61,31,0.2)`,
            padding: '64px 0 48px 0',
            scrollMarginTop: 96,
            width: '100%'
        }}>
            <div style={{
                margin: '0 auto',
                maxWidth: 1280,
                padding: '0 16px',
                width: '100%'
            }}>
                <div style={{
                    margin: '0 auto',
                    maxWidth: 768
                }}>
                    <div style={{
                        marginBottom: 32,
                        textAlign: 'center'
                    }}>
                        <h2 style={{
                            color: SECONDARY_DARK,
                            fontFamily: '"Poppins", sans-serif',
                            fontSize: isMobile ? 32 : 48,
                            fontWeight: 700,
                            margin: '0 0 24px 0'
                        }}>{'Start Protecting Your Home Today'}</h2>
                        <div style={{
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 16,
                            marginBottom: 24
                        }}>
                            <div style={{ position: 'relative' }}>
                                <div style={{
                                    background: `linear-gradient(90deg, rgba(214,61,31,0.6), rgba(255,107,61,0.5), rgba(214,61,31,0.6))`,
                                    borderRadius: '50%',
                                    bottom: -20,
                                    filter: 'blur(32px)',
                                    left: -20,
                                    opacity: 0.8,
                                    position: 'absolute',
                                    right: -20,
                                    top: -20
                                }} />
                                <img
                                alt={'Free Emergency Fire Blanket'}
                                src={require('assets/fire-blanket.png')}
                                style={{
                                    height: 208,
                                    objectFit: 'contain',
                                    position: 'relative',
                                    width: 208
                                }} />
                            </div>
                            <p style={{
                                color: '#6F6F6F',
                                fontFamily: '"Lato", sans-serif',
                                fontSize: 16,
                                lineHeight: 1.6,
                                margin: '0 auto',
                                maxWidth: 512,
                                textAlign: 'center'
                            }}>
                                {'Secure your '}
                                <span style={{ color: FIRE, fontWeight: 600 }}>{'FREE $99.99 Emergency Fire Blanket'}</span>
                                {' with your home safety inspection.'}
                            </p>
                        </div>
                    </div>
                    <div style={{
                        backgroundColor: '#FFFFFF',
                        border: `1px solid rgba(214,61,31,0.15)`,
                        borderRadius: 16,
                        boxShadow: '0 10px 30px -10px rgba(214,61,31,0.25)',
                        margin: '0 auto',
                        maxWidth: 576,
                        padding: isMobile ? 24 : 32
                    }}>
                        <form onSubmit={onZipSubmit}>
                            <div style={{ textAlign: 'center' }}>
                                <label
                                htmlFor={'contact-zip'}
                                style={{
                                    color: SECONDARY_DARK,
                                    display: 'block',
                                    fontFamily: '"Poppins", sans-serif',
                                    fontSize: isMobile ? 15 : 17,
                                    fontWeight: 600,
                                    paddingBottom: 12
                                }}>
                                    {'Schedule Your Free Home Safety Inspection.'}
                                    <br />
                                    {`Enter Your ${isCanada ? 'Postal Code' : 'ZIP code'} `}
                                    <span style={{ color: FIRE }}>{'*'}</span>
                                </label>
                                <div style={{
                                    alignItems: 'stretch',
                                    display: 'flex',
                                    flexDirection: isMobile ? 'column' : 'row',
                                    gap: 12,
                                    justifyContent: 'center'
                                }}>
                                    <input
                                    autoComplete={'postal-code'}
                                    id={'contact-zip'}
                                    inputMode={'numeric'}
                                    maxLength={5}
                                    onChange={onZipChange}
                                    placeholder={`Enter Your ${isCanada ? 'postal code' : 'ZIP Code'}`}
                                    type={'text'}
                                    value={zip}
                                    style={{
                                        backgroundColor: '#FFFFFF',
                                        border: `1px solid ${zipError ? FIRE : 'rgba(220,220,220,0.6)'}`,
                                        borderRadius: 8,
                                        color: '#1E1E1E',
                                        flex: isMobile ? 'none' : 1,
                                        fontFamily: '"Open Sans", sans-serif',
                                        fontSize: 16,
                                        height: 48,
                                        maxWidth: isMobile ? '100%' : 320,
                                        outline: 'none',
                                        padding: '0 20px',
                                        textAlign: 'center'
                                    }} />
                                    <button
                                    type={'submit'}
                                    style={{
                                        alignItems: 'center',
                                        background: `linear-gradient(90deg, ${FIRE}, ${FIRE_GLOW})`,
                                        border: 'none',
                                        borderRadius: 8,
                                        color: '#FFFFFF',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        fontFamily: '"Lato", sans-serif',
                                        fontSize: 18,
                                        fontWeight: 700,
                                        gap: 8,
                                        height: 48,
                                        justifyContent: 'center',
                                        padding: '0 24px',
                                        transition: 'transform 0.3s'
                                    }}
                                    onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.05)'; }}
                                    onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}>
                                        <i className={'fas fa-calendar'} style={{ fontSize: 18 }} />
                                        {'Schedule Inspection'}
                                    </button>
                                </div>
                                {zipError && (
                                    <p style={{
                                        color: FIRE,
                                        fontFamily: '"Open Sans", sans-serif',
                                        fontSize: 14,
                                        margin: '8px 0 0 0'
                                    }}>{zipError}</p>
                                )}
                            </div>
                        </form>
                    </div>
                    <p style={{
                        color: 'rgba(111,111,111,0.7)',
                        fontFamily: '"Open Sans", sans-serif',
                        fontSize: 10,
                        lineHeight: 1.6,
                        margin: '24px 0 0 0',
                        textAlign: 'center'
                    }}>{'By providing the requested personal information, you are consenting to being contacted – by phone, email, and/or SMS text – by an authorized representative of a company that carries home fire safety products, performs in-person consultations, and delivers emergency preparedness kits and fire blankets.'}</p>
                </div>
            </div>
        </section>
    )
}

export default ContactForm;
